<!-- COMPONENT IS USED IN HAULAGE/VEHICLE SCHEDULE AND TRACKING ( RIGHT MENU ) -->

<template>
  <div class="status-task-main">



    <!-- UPPER WHITE CONTAINER DETAILS -->
    <div class="white-container">
      <div class="left-cont">
        <div class="left-row">
          <span>{{ !receivedData ? '' : receivedData['ContainerNo'] === '' || !receivedData['ContainerNo'] ? '-' : receivedData['ContainerNo']}}</span>
          <span>{{contSzTyp}}</span>
        </div>
        <div class="left-row" :style="{display : (!receivedData || !receivedData['B2BContainerNo']) ? 'none' : ''}">
          <span>{{ !receivedData ? '' : receivedData['B2BContainerNo'] === '' || !receivedData['B2BContainerNo'] ? '-' : receivedData['B2BContainerNo']}}</span>
          <span>{{b2BcontSzTyp}}</span>
        </div>
        <div class="left-row">
          <span>{{ !receivedData ? '' : receivedData['ConsignmentNo'] === '' || !receivedData['ConsignmentNo']  ? '-' : receivedData['ConsignmentNo']}}</span>
          <span>{{ !receivedData ? '' : receivedData['MovementType'] === '' || !receivedData['MovementType']  ? '-' : receivedData['MovementType']}}</span>
        </div>
        <div class="left-row">
          <span>{{ !receivedData ? '' : receivedData['BillToName'] === '' || !receivedData['BillToName']  ? '-' : receivedData['BillToName']}}</span>
          <span>{{depDestCodeArea}}</span>
        </div>
      </div>
      <div class="right-cont">
        <Tooltip v-if="!receivedData ? false : (receivedData['PickupIn'] || receivedData['PickupOut'] || receivedData['DropoffIn'] || receivedData['DropoffOut'])" :showIndicator="false" :iconSize="18" position="left" :minWidth="200">
          <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/TruckOn.png"/>
          <div slot="tooltipText">
            <span>Next Action : {{( !receivedData ? '-' : receivedData['DropoffIn'] ? 'Drop Off Out' : (receivedData['PickupOut'] ? 'Drop Off In' : (receivedData['PickupIn'] ? 'Pick Up Out' : 'Pick Up In'))) }}</span>
          </div>
        </Tooltip>

        <div class="right-cont-lower">
          <Tooltip v-if="receivedData && receivedData['cmbook']" :showIndicator="false" :iconSize="18" position="left" :minWidth="250">
            <img style="width: 18px; height: 18px;" src="https://dsmlib.logistics.systems/Icons/icon8-booking.png"/>
            <div slot="tooltipText">
              <span>Port/Depot Bkg : {{ `${!receivedData  ? '-' : !receivedData['cmbookid']? '-' : receivedData['cmbookid']} by ${!receivedData  ? '-' : !receivedData['cmbookuser']? '-' : receivedData['cmbookuser']}` }}</span>
              <br>
              <span>Bkg Remarks : {{ !receivedData  ? '-' : !receivedData['cmbookremarks']? '-' : receivedData['cmbookremarks'] }}</span>
            </div>
          </Tooltip>
          <Tooltip style="cursor: pointer;" @click.native="consignmentDetailShow = !consignmentDetailShow;" :iconSize="18" position="left" :minWidth="150" tooltipText="Consignment Details"/>
        </div>

      </div>
    </div>


    <!-- WHEN INFO TOOLTIP IN UPPER WHITE CONTAINER DETAILS IS CLICKED -->
    <div v-show="consignmentDetailShow" class="consignment-details">
      <div class="consignment-detail-close">
        <button @click="consignmentDetailShow = false;">Close</button>
        <!-- // <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" @click="consignmentDetailShow = false;"/> -->
      </div>
      <div class="tab-row">
        <span>Trip #</span>
        <span>{{!receivedData ? '-' : !receivedData['JINo'] ? '-' : receivedData['JINo']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['MovementType'] ? '-' : receivedData['MovementType']}}</span>
      </div>
      <div class="tab-row">
        <span>Cust</span>
        <span>{{!receivedData ? '-' : !receivedData['BillToName'] ? '-' : receivedData['BillToName']}}</span>
      </div>
      <div class="tab-row">
        <span>Cont #</span>
        <span>{{!receivedData ? '-' : !receivedData['ContainerNo'] ? '-' : receivedData['ContainerNo']}}</span>
        <span>{{contSzTyp}}</span>
      </div>
      <div class="tab-row">
        <span>B2B</span>
        <span>{{!receivedData ? '-' : !receivedData['B2BContainerNo'] ? '-' : receivedData['B2BContainerNo']}}</span>
      </div>
      <div class="tab-row">
        <span>B2B CN</span>
        <span>{{!receivedData ? '-' : !receivedData['B2BConsignmentNo'] ? '-' : receivedData['B2BConsignmentNo']}}</span>
      </div>
      <div class="tab-row">
        <span>Bkg Ref</span>
        <span>{{!receivedData ? '-' : !receivedData['BookingRefNo'] ? '-' : receivedData['BookingRefNo']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['ShipCall_No'] ? '-' : receivedData['ShipCall_No']}}</span>
      </div>
      <div class="tab-row">
        <span>From</span>
        <span>{{!receivedData ? '-' : !receivedData['FromDestCode'] ? '-' : receivedData['FromDestCode']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['FromArea'] ? '-' : receivedData['FromArea']}}</span>
      </div>
      <div class="tab-row">
        <span>Tel #</span>
        <span>{{!receivedData ? '-' : !receivedData['FromTelNo1'] ? '-' : receivedData['FromTelNo1']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['FromTelNo2'] ? '-' : receivedData['FromTelNo2']}}</span>
      </div>
      <div class="tab-row">
        <span>Address</span>
        <span v-html="addressFrom"></span>
      </div>
      <div class="tab-row">
        <span>To</span>
        <span>{{!receivedData ? '-' : !receivedData['ToDestCode'] ? '-' : receivedData['ToDestCode']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['ToArea'] ? '-' : receivedData['ToArea']}}</span>
      </div>
      <div class="tab-row">
        <span>Tel #</span>
        <span>{{!receivedData ? '-' : !receivedData['ToTelNo1'] ? '-' : receivedData['ToTelNo1']}}</span>
        <span>{{!receivedData ? '-' : !receivedData['ToTelNo2'] ? '-' : receivedData['ToTelNo2']}}</span>
      </div>
      <div class="tab-row">
        <span>Address</span>
        <span v-html="addressTo"></span>
      </div>
      <div class="tab-row">
        <span>B2B To</span>
        <span>{{!receivedData ? '-' : !receivedData['B2BToDestCode'] ? '-' : receivedData['B2BToDestCode']}}</span>
      </div>
      <div class="tab-row">
        <span>Operator</span>
        <span>{{!receivedData ? '-' : !receivedData['Operator'] ? '-' : receivedData['Operator']}}</span>
      </div>
      <div class="tab-row">
        <span>Port/Depot Bkg</span>
        <span>{{portDepotBookingText}}</span>
      </div>
      <div class="tab-row">
        <span>Bkg Remarks</span>
        <span>{{!receivedData ? '-' : !receivedData['cmbookremarks'] ? '-' : receivedData['cmbookremarks']}}</span>
      </div>
      <div class="tab-row">
        <span>PU In/Out</span>
        <span style="white-space: nowrap;">
          {{
            !rcPickUpInDatetime ? '[]' : `[${rcPickUpInDatetime.formatString('yyyy-MM-dd HH:mm:ss')}]`
          }}
          /
          <wbr>
          {{
            !rcPickUpOutDatetime ? '[]' : `[${rcPickUpOutDatetime.formatString('yyyy-MM-dd HH:mm:ss')}]`
          }}
        </span>
      </div>
      <div class="tab-row">
        <span>DO In/Out</span>
        <span style="white-space: nowrap;">
          {{
            !rcDropOffInDatetime ? '[]' : `[${rcDropOffInDatetime.formatString('yyyy-MM-dd HH:mm:ss')}]`
          }}
          /
          <wbr>
          {{
            !rcDropOffOutDatetime ? '[]' : `[${rcDropOffOutDatetime.formatString('yyyy-MM-dd HH:mm:ss')}]`
          }}
        </span>
      </div>
    </div>


    <!--Update Status Task  -->
    <div v-show="!consignmentDetailShow" class="radio-call-section">
    <!-- Pick Up In -->
      <div class="radio-call-container">
        <div class="radio-call-title">
          Pick Up In
          {{receivedData && receivedData['FromDestCode'] ? `- (${receivedData['FromDestCode']})` : '' }}
        </div>
        <div class="radio-call-content">
          <div v-if="rcPickUpInIsDisabled" class="radio-call-container-disabled">
            <div v-if="rcPickUpInHasSaved" class="reverse-status" @click="reverseStatusClicked('PUI')">
              <img src="https://dsmlib.logistics.systems/Icons/Undo.png" alt="Reverse" draggable="false">
              <span>Reverse Status</span>
            </div>
          </div>
          <div class="radio-call-content-left">
            <DateTimePicker placeholder="Date/Time" :value.sync="rcPickUpInDatetime" :isRequired="true" :errorMessage.sync="rcPickUpInDatetimeError"/>
            <Dropdown v-if="receivedData && receivedData['PMisSideloader'] == '0'" placeholder="TR Reg #" :selectedObject.sync="rcTrailerInput" :items="rcTrailers" itemKey="Keyname" :isRequired="true" :errorMessage.sync="rcTrailerError"/>
            <RemarksBox class="remarks-box" :text.sync="rcPickUpInRemarks" />
          </div>
          <div class="radio-call-content-right">
            <img :src="rcAttachmentImage" alt="Upload Attachments" @click="uploadAttachmentsClicked('PUI')">
            <img :src="rcUpdateImage" alt="Update Status" @click="saveClicked($event, 'Pick Up In')">
          </div>
        </div>
        <div class="radio-call-attachments">
          <div class="radio-call-attachments-header" @click="rcPickUpInAttachmentsExpanded = !rcPickUpInAttachmentsExpanded">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${rcPickUpInAttachmentsExpanded ? 0 : 180}deg)`}">
            <span style="font-weight: bold;">Attachments ({{rcPickUpInAttachments.length}})</span>
            <div v-if="rcPickUpInAttachments.filter((attachment) => { return attachment['newlyUploadedByUser']; }).length > 0" class="unsaved-attachment-indicator"></div>
          </div>
          <div class="radio-call-attachments-content" :style="{'max-height': `${rcPickUpInAttachmentsExpanded ? Math.ceil(rcPickUpInAttachments.length / rcAttachmentsPerRow) * 100 : 0}px`}">
            <div class="radio-call-attachments-row" v-for="row in Math.floor(rcPickUpInAttachments.length / rcAttachmentsPerRow)" :key="row">
              <div class="radio-call-attachment-thumbnail" v-for="col in rcAttachmentsPerRow" :key="col">
                <img class="thumbnail" :src="getThumbnailDataURL(rcPickUpInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1])"
                  :title="rcPickUpInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment((row - 1) * rcAttachmentsPerRow + col - 1, 'Pick Up In');"
                  draggable="false"
                >
                <img v-if="rcPickUpInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
            <div class="radio-call-attachments-row incomplete"> <!-- last row, not enough files to fill up the entire row (may or may not be shown) -->
              <div class="radio-call-attachment-thumbnail" v-for="col in rcPickUpInAttachments.length % rcAttachmentsPerRow" :key="col" :style="{'margin-right': `${(rightMenuWidth - 45 - rcAttachmentsPerRow * 82.5) / (rcAttachmentsPerRow - 1)}px`}">
                <img class="thumbnail" :src="getThumbnailDataURL(rcPickUpInAttachments[Math.floor(rcPickUpInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1])"
                  :title="rcPickUpInAttachments[Math.floor(rcPickUpInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment(Math.floor(rcPickUpInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1, 'Pick Up In')"
                  draggable="false"
                >
                <img v-if="rcPickUpInAttachments[Math.floor(rcPickUpInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pick Up Out -->
      <div class="radio-call-container">
        <div class="radio-call-title">
          Pick Up Out
          {{receivedData && receivedData['FromDestCode'] ? `- (${receivedData['FromDestCode']})` : '' }}
        </div>
        <div class="radio-call-content">
          <div v-if="rcPickUpOutIsDisabled" class="radio-call-container-disabled">
            <div v-if="rcPickUpOutHasSaved" class="reverse-status" @click="reverseStatusClicked('PUO')">
              <img src="https://dsmlib.logistics.systems/Icons/Undo.png" alt="Reverse" draggable="false">
              <span>Reverse Status</span>
            </div>
            <div v-else class="not-ready">
              <span>Complete Pick Up In First</span>
            </div>
          </div>
          <div class="radio-call-content-left">
            <div style="display: flex; flex-direction: row;">
              <div style="margin-right: 3px; flex: 1;">
                <Input placeholder="Request #" :inputValue.sync="rcRequestNoInput" :isDisabled="true"/>
                <Input v-if="receivedData && !receivedData['BookingRefNo']" placeholder="Bill of Lading #" :inputValue.sync="rcBillOfLadingNoInput" :isDisabled="true"/>
                <Input v-if="receivedData && receivedData['BookingRefNo']" placeholder="Bkg Ref #" :inputValue.sync="rcBookingRefNoInput" :isDisabled="true"/>
                <Input :isRequired="true" placeholder="Container #" :inputValue.sync="rcContainerNoInput" :isDisabled="receivedData && receivedData['ContainerNo'] != ''" :errorMessage="rcContainerNoError" :isContainer="true"/> <!-- JS doesn't infer empty strings as false, for some reason -->
                <Input placeholder="Seal #" :inputValue.sync="rcSealNoInput"/>
              </div>
              <div v-if="receivedData && receivedData['B2BJourneyGUID']" style="margin-left: 3px; flex: 1;">
                <!-- <hr style="border-width: 5px; border-color: gray;"> -->
                <Input placeholder="B2B Request #" :inputValue.sync="rcB2BRequestNoInput" :isDisabled="true"/>
                <Input v-if="receivedData && !receivedData['B2BBookingRefNo']" placeholder="B2B Bill of Lading #" :inputValue.sync="rcB2BBillOfLadingNoInput" :isDisabled="true"/>
                <Input v-if="receivedData && receivedData['B2BBookingRefNo']" placeholder="B2B Bkg Ref #" :inputValue.sync="rcB2BBookingRefNoInput" :isDisabled="true"/>
                <Input placeholder="B2B Container #" :inputValue.sync="rcB2BContainerNoInput" :isDisabled="receivedData && receivedData['B2BContainerNo'] != ''" :errorMessage="rcB2BContainerNoError" :isContainer="true"/> <!-- JS doesn't infer empty strings as false, for some reason -->
                <Input placeholder="B2B Seal #" :inputValue.sync="rcB2BSealNoInput"/>
              </div>
            </div>
            <!-- <hr style="border-width: 5px; border-color: gray;"> -->
            <DateTimePicker placeholder="Date/Time" :value.sync="rcPickUpOutDatetime" :isRequired="true" :errorMessage.sync="rcPickUpOutDatetimeError"/>
            <RemarksBox class="remarks-box" :text.sync="rcPickUpOutRemarks"/>
          </div>
          <div class="radio-call-content-right">
            <img :src="rcAttachmentImage" alt="Upload Attachments" @click="uploadAttachmentsClicked('PUO')">
            <img @click="saveClicked($event, 'Pick Up Out')" :src="rcUpdateImage" alt="">
          </div>
        </div>
        <div class="radio-call-attachments">
          <div class="radio-call-attachments-header" @click="rcPickUpOutAttachmentsExpanded = !rcPickUpOutAttachmentsExpanded">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${rcPickUpOutAttachmentsExpanded ? 0 : 180}deg)`}">
            <span style="font-weight: bold;">Attachments ({{rcPickUpOutAttachments.length}})</span>
            <div v-if="rcPickUpOutAttachments.filter((attachment) => { return attachment['newlyUploadedByUser']; }).length > 0" class="unsaved-attachment-indicator"></div>
          </div>
          <div class="radio-call-attachments-content" :style="{'max-height': `${rcPickUpOutAttachmentsExpanded ? Math.ceil(rcPickUpOutAttachments.length / rcAttachmentsPerRow) * 100 : 0}px`}">
            <div class="radio-call-attachments-row" v-for="row in Math.floor(rcPickUpOutAttachments.length / rcAttachmentsPerRow)" :key="row">
              <div class="radio-call-attachment-thumbnail" v-for="col in rcAttachmentsPerRow" :key="col">
                <img class="thumbnail" :src="getThumbnailDataURL(rcPickUpOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1])"
                  :title="rcPickUpOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment((row - 1) * rcAttachmentsPerRow + col - 1, 'Pick Up Out')"
                >
                <img v-if="rcPickUpOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
            <div class="radio-call-attachments-row incomplete"> <!-- last row, not enough files to fill up the entire row (may or may not be shown) -->
              <div class="radio-call-attachment-thumbnail" v-for="col in rcPickUpOutAttachments.length % rcAttachmentsPerRow" :key="col" :style="{'margin-right': `${(rightMenuWidth - 45 - rcAttachmentsPerRow * 82.5) / (rcAttachmentsPerRow - 1)}px`}">
                <img class="thumbnail" :src="getThumbnailDataURL(rcPickUpOutAttachments[Math.floor(rcPickUpOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1])"
                  :title="rcPickUpOutAttachments[Math.floor(rcPickUpOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment(Math.floor(rcPickUpOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1, 'Pick Up Out')"
                >
                <img v-if="rcPickUpOutAttachments[Math.floor(rcPickUpOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Drop Off In -->
      <div class="radio-call-container">
        <div class="radio-call-title">
          Drop Off In
          {{receivedData && receivedData['ToDestCode'] ? `- (${receivedData['ToDestCode']})` : '' }}
        </div>
        <div class="radio-call-content">
          <div v-if="rcDropOffInIsDisabled" class="radio-call-container-disabled">
            <div v-if="rcDropOffInHasSaved" class="reverse-status" @click="reverseStatusClicked('DOI')">
              <img src="https://dsmlib.logistics.systems/Icons/Undo.png" alt="Reverse" draggable="false">
              <span>Reverse Status</span>
            </div>
            <div v-else class="not-ready">
              <span>Complete Pick Up Out First</span>
            </div>
          </div>
          <div class="radio-call-content-left">
            <DateTimePicker placeholder="Date/Time" :value.sync="rcDropOffInDatetime" :isRequired="true" :errorMessage.sync="rcDropOffInDatetimeError"/>
            <RemarksBox class="remarks-box" :text.sync="rcDropOffInRemarks"/>
          </div>
          <div class="radio-call-content-right">
            <img :src="rcAttachmentImage" alt="Upload Attachments" @click="uploadAttachmentsClicked('DOI')">
            <img @click="saveClicked($event, 'Drop Off In')" :src="rcUpdateImage" alt="">
          </div>
        </div>
        <div class="radio-call-attachments">
          <div class="radio-call-attachments-header" @click="rcDropOffInAttachmentsExpanded = !rcDropOffInAttachmentsExpanded">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${rcDropOffInAttachmentsExpanded ? 0 : 180}deg)`}">
            <span style="font-weight: bold;">Attachments ({{rcDropOffInAttachments.length}})</span>
            <div v-if="rcDropOffInAttachments.filter((attachment) => { return attachment['newlyUploadedByUser']; }).length > 0" class="unsaved-attachment-indicator"></div>
          </div>
          <div class="radio-call-attachments-content" :style="{'max-height': `${rcDropOffInAttachmentsExpanded ? Math.ceil(rcDropOffInAttachments.length / rcAttachmentsPerRow) * 100 : 0}px`}">
            <div class="radio-call-attachments-row" v-for="row in Math.floor(rcDropOffInAttachments.length / rcAttachmentsPerRow)" :key="row">
              <div class="radio-call-attachment-thumbnail" v-for="col in rcAttachmentsPerRow" :key="col">
                <img class="thumbnail" :src="getThumbnailDataURL(rcDropOffInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1])"
                  :title="rcDropOffInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment((row - 1) * rcAttachmentsPerRow + col - 1, 'Drop Off In')"
                >
                <img v-if="rcDropOffInAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
            <div class="radio-call-attachments-row incomplete"> <!-- last row, not enough files to fill up the entire row (may or may not be shown) -->
              <div class="radio-call-attachment-thumbnail" v-for="col in rcDropOffInAttachments.length % rcAttachmentsPerRow" :key="col" :style="{'margin-right': `${(rightMenuWidth - 45 - rcAttachmentsPerRow * 82.5) / (rcAttachmentsPerRow - 1)}px`}">
                <img class="thumbnail" :src="getThumbnailDataURL(rcDropOffInAttachments[Math.floor(rcDropOffInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1])"
                  :title="rcDropOffInAttachments[Math.floor(rcDropOffInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment(Math.floor(rcDropOffInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1, 'Drop Off In')"
                >
                <img v-if="rcDropOffInAttachments[Math.floor(rcDropOffInAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Drop Off Out -->
      <div class="radio-call-container">
        <div class="radio-call-title">
          Drop Off Out
          {{receivedData && receivedData['ToDestCode'] ? `- (${receivedData['ToDestCode']})` : '' }}
        </div>
        <div class="radio-call-content">
          <div v-if="rcDropOffOutIsDisabled" class="radio-call-container-disabled">
            <div v-if="rcDropOffOutHasSaved" class="reverse-status" @click="reverseStatusClicked('DOO')">
              <img src="https://dsmlib.logistics.systems/Icons/Undo.png" alt="Reverse" draggable="false">
              <span>Reverse Status</span>
            </div>
            <div v-else class="not-ready">
              <span>Complete Drop Off In First</span>
            </div>
          </div>
          <div class="radio-call-content-left">
            <DateTimePicker placeholder="Date/Time" :value.sync="rcDropOffOutDatetime" :isRequired="true" :errorMessage.sync="rcDropOffOutDatetimeError"/>
            <CheckBox title="TR Potong" :isChecked.sync="rcTrPotongChecked"/>
            <RemarksBox class="remarks-box" :text.sync="rcDropOffOutRemarks"/>
          </div>
          <div class="radio-call-content-right">
            <img :src="rcAttachmentImage" alt="Upload Attachments" @click="uploadAttachmentsClicked('DOO')">
            <img @click="saveClicked($event, 'Drop Off Out')" :src="rcUpdateImage" alt="">
          </div>
        </div>
        <div class="radio-call-attachments">
          <div class="radio-call-attachments-header" @click="rcDropOffOutAttachmentsExpanded = !rcDropOffOutAttachmentsExpanded">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png" alt="expand arrow" :style="{'transform': `rotate(${rcDropOffOutAttachmentsExpanded ? 0 : 180}deg)`}">
            <span style="font-weight: bold;">Attachments ({{rcDropOffOutAttachments.length}})</span>
            <div v-if="rcDropOffOutAttachments.filter((attachment) => { return attachment['newlyUploadedByUser']; }).length > 0" class="unsaved-attachment-indicator"></div>
          </div>
          <div class="radio-call-attachments-content" :style="{'max-height': `${rcDropOffOutAttachmentsExpanded ? Math.ceil(rcDropOffOutAttachments.length / rcAttachmentsPerRow) * 100 : 0}px`}">
            <div class="radio-call-attachments-row" v-for="row in Math.floor(rcDropOffOutAttachments.length / rcAttachmentsPerRow)" :key="row">
              <div class="radio-call-attachment-thumbnail" v-for="col in rcAttachmentsPerRow" :key="col">
                <img class="thumbnail" :src="getThumbnailDataURL(rcDropOffOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1])"
                  :title="rcDropOffOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment((row - 1) * rcAttachmentsPerRow + col - 1, 'Drop Off Out')"
                >
                <img v-if="rcDropOffOutAttachments[(row - 1) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
            <div class="radio-call-attachments-row incomplete"> <!-- last row, not enough files to fill up the entire row (may or may not be shown) -->
              <div class="radio-call-attachment-thumbnail" v-for="col in rcDropOffOutAttachments.length % rcAttachmentsPerRow" :key="col" :style="{'margin-right': `${(rightMenuWidth - 45 - rcAttachmentsPerRow * 82.5) / (rcAttachmentsPerRow - 1)}px`}">
                <img class="thumbnail" :src="getThumbnailDataURL(rcDropOffOutAttachments[Math.floor(rcDropOffOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1])"
                  :title="rcDropOffOutAttachments[Math.floor(rcDropOffOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['picname'].trim()"
                  @click="projectAttachment(Math.floor(rcDropOffOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1, 'Drop Off Out')"
                >
                <img v-if="rcDropOffOutAttachments[Math.floor(rcDropOffOutAttachments.length / rcAttachmentsPerRow) * rcAttachmentsPerRow + col - 1]['newlyUploadedByUser']"
                  class="unsaved-attachment-indicator"
                  src="https://dsmlib.logistics.systems/Icons/New.png"
                  alt="Unsaved Attachment"
                  title="Unsaved Attachment"
                  draggable="false"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PopupV2
      class="reverse-status-popup"
      :show="showReverseStatusPopup"
      :title="reverseStatusPopupTitle"
      :buttons="reverseStatusPopupButtons"
      @buttonClicked="reverseStatusPopupButtonClicked"
    >
      <div class="reverse-status-popup-content">
        <span>You are about to reverse {{reverseStatusPopupPrompt}}.<br/>Are you sure?</span>
        <Input
          placeholder="Please state your reason"
          :inputValue.sync="reverseStatusPopupReason"
          :isRequired="true"
          :errorMessage.sync="reverseStatusPopupErrorMessage"/>
      </div>
    </PopupV2>

    <PopupV2
      class="attachments-popup"
      :show="showAttachmentsPopup"
      :icon="rcAttachmentImage"
      title="Upload Attachments"
      :buttons="attachmentsPopupButtons"
      @buttonClicked="attachmentsPopupButtonClicked"
    >
      <div class="attachments-popup-content">
        <div class="input-container">
          <Input textType="file" placeholder="Browse" :multiFile="true" @fileChanged="attachmentsSelected"/>
        </div>
      </div>
    </PopupV2>

    <div v-if="showAttachmentsProjector" class="attachments-projector-container">
      <div class="close-button" @click="hideProjection()">
        &times;
      </div>
      <div class="attachments-projector">
        <div class="attachment-projection-container">
          <div class="previous-attachment" @click="projectPreviousAttachment()"> &lt; </div>
          <div class="attachment-projection">
            <object v-if="attachmentIsProjectable && showAttachmentProjection"
              :type="projectedAttachment['pictype'].trim()"
              :data="`data:${projectedAttachment['pictype'].trim()};base64,${projectedAttachment['picimage']}`"
              draggable="false"
            >
            </object>
            <div v-else>
              <span>
                {{ ((filename) => { const split = filename.split("."); return split[split.length - 1].toUpperCase(); })(projectedAttachment['picname'].trim()) }} files cannot be previewed.
                Please download the file and view it instead.
              </span>
              <button @click="downloadAttachment(projectedAttachment)">
                <img src="https://dsmlib.logistics.systems/Icons/Download.png" alt="Download icon">
                Download
              </button>
            </div>
          </div>
          <div class="next-attachment" @click="projectNextAttachment()"> &gt; </div>
        </div>
        <div class="attachment-details">
          <div class="header">{{ projectedAttachmentAction }} Attachments</div>
          <table border="1">
            <tr>
              <th>Attachment</th>
              <td>{{ projectedAttachmentIndex + 1 }} of {{ projectedAttachmentListLength }}</td>
            </tr>
            <tr>
              <th>Attachment Name</th>
              <td>{{ projectedAttachment["picname"] }}</td>
            </tr>
            <tr>
              <th>Attachment Type</th>
              <td>{{ attachmentFileType }}</td>
            </tr>
          </table>
          <div class="attachment-map-container" v-if="projectedAttachment['gpslatitude'] && projectedAttachment['gpslongitude']">
            <b>Image taken from:</b>
            <CustomMap :markers="projectedAttachmentLocation" :maxMarkerCount="1" :viewMode="true" :hideSlot="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  computed : {
    contSzTyp : function () {
      if (!this.receivedData) {
        return ''
      }
      return `${this.receivedData['ContSize']}${this.receivedData['ContType']}`
    },
    b2BcontSzTyp : function () {
      if (!this.receivedData) {
        return ''
      }
      return `${this.receivedData['B2BContSize']}${this.receivedData['B2BContType']}`
    },
    depDestCodeArea : function () {
      if (!this.receivedData) {
        return ''
      }
      let temp =  this.$jsonNullToStringV2(this.receivedData)
      return `${temp['FromDestCode']} (${temp['FromArea']}) - ${temp['ToDestCode']} (${temp['ToArea']})]`
    },
    addressFrom : function () {
      if (!this.receivedData) {
        return ''
      } else {
        if (this.receivedData['FromAddress'] && this.receivedData['FromAddress'].includes('\r')) {
          return this.receivedData['FromAddress'].split('\r').join('<br>');
        }
        return this.receivedData['FromAddress'] || ''
      }
    },
    addressTo : function () {
      if (!this.receivedData) {
        return ''
      } else {
        if (this.receivedData['ToAddress'] && this.receivedData['ToAddress'].includes('\r')) {
          return this.receivedData['ToAddress'].split('\r').join('<br>');
        }
        return this.receivedData['ToAddress'] || ''
      }
    },
    portDepotBookingText : function () {
      if (!this.receivedData) {
        return ''
      } else {
        return `${!this.receivedData['cmbookid'] ? '-' : this.receivedData['cmbookid']} by ${!this.receivedData['cmbookuser'] ? '-' : this.receivedData['cmbookuser']}`
      }
    },
    rcAttachmentsPerRow : function() { // min and max width of right menu is 330px and 550px, it's set in VehicleScheduleV4
      if (this.rightMenuWidth < 395)
        return 3;
      
      if (this.rightMenuWidth < 485)
        return 4;

      return 5;

      // <395px - 3 per row
      // 395-485 - 4 per row
      // >485px - 5 per row
    },
    attachmentIsProjectable: function() {
      if (!this.projectedAttachment) {
        return false;
      }
      const filenameSplit = this.projectedAttachment["picname"].trim().split(".");
      const fileExtension = filenameSplit[filenameSplit.length - 1];
      const MIMEType = this.projectedAttachment["pictype"].trim();
      const projectableExtensions = ["pdf", "txt", "json", "mp3", "wav", "mp4", "webm", "ogg"];
      
      return MIMEType.startsWith("image/") || projectableExtensions.includes(fileExtension);
    },
    attachmentFileType: function() {
      if (!this.projectedAttachment) {
        return "";
      }

      const MIMEType = this.projectedAttachment["pictype"].trim();
      if (MIMEType.startsWith("image/")) {
        return "Image";
      }
      if (MIMEType.startsWith("video/")) {
        return "Video";
      }
      if (MIMEType.startsWith("audio/")) {
        return "Audio";
      }
      if (MIMEType.startsWith("text/")) {
        return "Text";
      }

      const filenameSplit = this.projectedAttachment["picname"].trim().split(".");
      const fileExtension = filenameSplit[filenameSplit.length - 1].toUpperCase();
      
      switch (fileExtension) {
        case "PDF":
          return "PDF Document";
          break;

        case "DOC":
        case "DOCX":
          return "WORD Document";
          break;

        case "PPT":
        case "PPTX":
          return "Presentation File"
          break;

        case "XLS":
        case "XLSX":
          return "Excel Spreadsheet"
          break;

        default:
          return "Unknown"
          break;
      }
    },
    projectedAttachmentListLength: function() {
      switch (this.projectedAttachmentAction) {
        case "Pick Up In":
          return this.rcPickUpInAttachments.length;
          break;
        case "Pick Up Out":
          return this.rcPickUpOutAttachments.length;
          break;
        case "Drop Off In":
          return this.rcDropOffInAttachments.length;
          break;
        case "Drop Off Out":
          return this.rcDropOffOutAttachments.length;
          break;
      }
    },
  },
  data: function() {
    return {
      receivedData : null,
      statusesAndAttachments : null,
      consignmentDetailShow : false,

      rcUpdateImage : 'https://dsmlib.logistics.systems/Icons/SaveStatic.png',
      rcAttachmentImage : 'https://dsmlib.logistics.systems/Icons/Attachment.png',

      //#region PUI
      rcPickUpInDatetime : null,
      rcPickUpInDatetimeError : '',
      rcTrailerInput : null,
      rcTrailerError : '',
      rcTrailers : [],
      rcPickUpInRemarks : '',
      rcPickUpInAttachmentsExpanded : true,
      rcPickUpInAttachments : [],
      
      rcPickUpInIsDisabled : true,
      rcPickUpInHasSaved : false,
      //#endregion

      //#region PUO
      rcPickUpOutDatetime : null,
      rcPickUpOutDatetimeError : '',
      rcSealNoInput : '',
      rcPickUpOutRemarks : '',
      rcPickUpOutAttachmentsExpanded : true,
      rcPickUpOutAttachments : [],

      rcPickUpOutIsDisabled : true,
      rcPickUpOutHasSaved : false,

      rcRequestNoInput : '',
      rcBillOfLadingNoInput : '',
      rcBookingRefNoInput : '',

      rcB2BRequestNoInput : '',
      rcB2BBillOfLadingNoInput : '',
      rcB2BBookingRefNoInput : '',
      rcB2BSealNoInput : '',

      rcContainerNoInput : '',
      rcContainerNoError : '',
      rcB2BContainerNoInput : '',
      rcB2BContainerNoError : '',
      //#endregion

      //#region DOI
      rcDropOffInDatetime : null,
      rcDropOffInDatetimeError : '',
      rcDropOffInRemarks : '',
      rcDropOffInAttachmentsExpanded : true,
      rcDropOffInAttachments : [],

      rcDropOffInIsDisabled : true,
      rcDropOffInHasSaved : false,
      //#endregion

      //#region DOO
      rcDropOffOutDatetime : null,
      rcDropOffOutDatetimeError : '',
      rcTrPotongChecked : false,
      rcDropOffOutRemarks : '',
      rcDropOffOutAttachmentsExpanded : true,
      rcDropOffOutAttachments : [],

      rcDropOffOutIsDisabled : true,
      rcDropOffOutHasSaved : false,
      //#endregion

      statusesToReverse: [], // stores the statuses needed to be reverse in order, iterate through when reversing more than 1 status at a time
      showReverseStatusPopup: false,
      reverseStatusPopupTitle: "",
      reverseStatusPopupButtons: [
        { "text": "OK" },
        { "text": "Cancel", "color": "lightgray" },
      ],
      reverseStatusPopupPrompt: "",
      reverseStatusPopupReason: "",
      reverseStatusPopupErrorMessage: "",

      showAttachmentsPopup: false,
      attachmentsPopupButtons: [
        { "text":"OK" },
        { "text":"Cancel", "color":"lightgray" },
      ],
      uploadAttachmentAction: '', // PUI | PUO | DOI | DOO, to indicate which action the user is uploading attachments for
      uploadAttachmentInputFiles: [],

      showAttachmentsProjector: false,
      showAttachmentProjection: true,
      projectedAttachment: null,
      projectedAttachmentAction: '', // Pick Up In | Pick Up Out | Drop Off In | Drop Off Out, to indicate which action attachments are being projected
      projectedAttachmentIndex: 0,
      projectedAttachmentLocation: null,
    }
  },
  props: {
    data : { type: Object, required: true, default: function() { return {}; } },
    rightMenuWidth : { type: Number, required: true, default: function() { return 0; } },
    attachmentsChanged: { type: Boolean, required: true, default: function() { return false } },
    // currently only updated when new attachments are added
    // in the future, remember to update it when attachments are removed
  },
  methods: {
    checkSaveValidity : function (result) {
      return result.find(i => i['Results'] == 0) ? true : false; // if b2b have 2 results - one of them results == 0 will return success
    },
    getThumbnailDataURL: function(attachment) {
      if (attachment["pictype"].startsWith("image/"))
        return `data:${attachment["pictype"].trim()};base64,${attachment["picimage"]}`;
      else
        return require(`../../node_modules/pretty-file-icons/svg/${this.$getFileIcon(attachment["picname"].trim())}`);
    },
    reverseStatusClicked: function(status) {
      let reverseCount = 1; // count the number of statuses needed to be reversed
      this.statusesToReverse = [status];
      this.reverseStatusPopupPrompt = status;
      switch (status) { // DO NOT ADD BREAK STATEMENTS
        case "PUI":
          if (this.rcPickUpOutHasSaved) { // it is supposed to cascade and calculate the number of statuses needed to be reversed
            reverseCount++;
            this.statusesToReverse.splice(0, 0, "PUO"); // add "PUO" to the front of the array
            this.reverseStatusPopupPrompt += ", PUO";
          }

        case "PUO":
          if (this.rcDropOffInHasSaved) {
            reverseCount++;
            this.statusesToReverse.splice(0, 0, "DOI"); // add "DOI" to the front of the array
            this.reverseStatusPopupPrompt += ", DOI";
          }

        case "DOI":
          if (this.rcDropOffOutHasSaved) {
            reverseCount++;
            this.statusesToReverse.splice(0, 0, "DOO"); // add "DOO" to the front of the array
            this.reverseStatusPopupPrompt += ", DOO";
          }
      }

      if (reverseCount == 1) {
        this.reverseStatusPopupTitle = `Reverse ${status}`;
      } else {
        this.reverseStatusPopupTitle = `Reverse ${reverseCount} statuses`;
      }

      this.reverseStatusPopupReason = "";
      this.showReverseStatusPopup = true;
    },
    reverseStatusPopupButtonClicked: async function(placeholder) {
      if (placeholder == "Cancel") {
        this.showReverseStatusPopup = false; // hide popup and dont do anything
        return;
      }

      if (this.reverseStatusPopupReason.trim() === "") {
        this.reverseStatusPopupErrorMessage = "Reverse reason is required";
        return;
      }

      this.showReverseStatusPopup = false;
      const reverseResults = []; // used to store API responses for all statuses reversed
      for (const statusToReverse of this.statusesToReverse) {
        const requestBody = {
          "journeyguid": !this.receivedData ? "" : !this.receivedData['JourneyGUID'] ? "" : this.receivedData['JourneyGUID'],
          "b2bjourneyguid": !this.receivedData ? "" : !this.receivedData['B2BJourneyGUID'] ? "" : this.receivedData['B2BJourneyGUID'],
          "status": "", // fill in later
          "tripaction": statusToReverse,
          "reversereason": this.reverseStatusPopupReason,
          "system": "HMS",
          "remarks": "", // leave blank for now
        };

        if (statusToReverse.startsWith("PU")) { // is either PUI or PUO
          requestBody["status"] = !this.receivedData ? "" : !this.receivedData["PickupStatus"] ? "" : this.receivedData["PickupStatus"];
        } else {
          requestBody["status"] = !this.receivedData ? "" : !this.receivedData["DropoffStatus"] ? "" : this.receivedData["DropoffStatus"];
        }

        this.$fullscreenLoading(`Reversing ${statusToReverse}`);
        const response = (await this.$apiCallV2("/VehicleSchedule/ReverseLastStatus", requestBody))[0]; // should always return an array
        reverseResults.splice( // add response to the beginning of the array
          0,
          0,
          {
            "Reversed Status": statusToReverse,
            "Response": response,
          }
        );

        if (response["Results"] !== 0) { // reverse unsuccessful
          break; // don't continue to reverse next status (if any)
        }

        switch (statusToReverse) {
          case "PUI":
            this.rcPickUpOutIsDisabled = true; // disable pick up out controls
            this.rcPickUpOutHasSaved = false; // hide reverse status button

            this.rcPickUpInIsDisabled = false; // enable pick up in controls
            this.rcPickUpInHasSaved = false; // hide reverse status button

            this.rcPickUpInDatetime = null; // clear pick up in datetimepicker
            this.rcTrailerInput = this.rcTrailers.find(i => i['VehicleCode'] == this.receivedData['TRCode']); // reset trailer dropdown
            this.rcPickUpInRemarks = ""; // clear pick up in remarks
            this.rcPickUpInAttachments = []; // clear pick up in attachments
            break;

          case "PUO":
            this.rcDropOffInIsDisabled = true; // disable drop off in controls
            this.rcDropOffInHasSaved = false; // hide reverse status button

            this.rcPickUpOutIsDisabled = false; // enable pick up out controls
            this.rcPickUpOutHasSaved = false; // hide reverse status button

            this.rcContainerNoInput = !this.receivedData['ContainerNo'] || !this.receivedData['ContainerNo'].trim() ? '' : this.receivedData['ContainerNo']; // reset if container # is already know from job data

            // this.rcSealNoInput = ""; // don't clear seal no, because it doesn't get changed in the database upon status reversal
            this.rcB2BContainerNoInput = !this.receivedData['B2BContainerNo'] || !this.receivedData['B2BContainerNo'].trim() ? '' : this.receivedData['B2BContainerNo']; // reset if container # is already known from job data
            // this.rcB2BSealNoInput = ""; // don't b2b seal no, because it doesn't get changed in the database upon status reversal
            this.rcPickUpOutDatetime = null; // clear pick up out datetimepicker
            this.rcPickUpOutRemarks = ""; // clear pick up out remarks
            this.rcPickUpOutAttachments = []; // clear pick up out attachments
            break;

          case "DOI":
            this.rcDropOffOutIsDisabled = true; // disable drop off out controls
            this.rcDropOffOutHasSaved = false; // hide reverse status button

            this.rcDropOffInIsDisabled = false; // enable drop off in controls
            this.rcDropOffInHasSaved = false; // hide reverse status button

            this.rcDropOffInDatetime = null; // clear drop off in datetimepicker
            this.rcDropOffInRemarks = ""; // clear drop off in remarks
            this.rcDropOffInAttachments = []; // clear drop off in attachments
            break;

          case "DOO":
            this.rcDropOffOutIsDisabled = false; // enable drop off out controls
            this.rcDropOffOutHasSaved = false; // hide reverse status button

            this.rcDropOffOutDatetime = null; // clear drop off out datetimepicker
            this.rcTrPotongChecked = false; // uncheck TR potong checkbox
            this.rcDropOffOutRemarks = ""; // uncheck drop off out remarks
            this.rcDropOffOutAttachments = []; // clear drop off out attachments
            break;
        }
      }
      this.$emit("statusReverse", reverseResults);
      this.$fullscreenLoading();
    },
    projectAttachment: function(attachmentIndex, action) {
      this.projectedAttachmentIndex = attachmentIndex;
      this.projectedAttachmentAction = action;
      switch (action) {
        case "Pick Up In":
          this.projectedAttachment = this.rcPickUpInAttachments[attachmentIndex];
          break;

        case "Pick Up Out":
          this.projectedAttachment = this.rcPickUpOutAttachments[attachmentIndex];
          break;

        case "Drop Off In":
          this.projectedAttachment = this.rcDropOffInAttachments[attachmentIndex];
          break;

        case "Drop Off Out":
          this.projectedAttachment = this.rcDropOffOutAttachments[attachmentIndex];
          break;
      }
      this.updateProjectedAttachmentLocation();
      this.showAttachmentsProjector = true;
    },
    hideProjection: function() {
      this.projectedAttachment = null;
      this.projectedAttachmentIndex = 0;
      this.projectedAttachmentAction = "";
      this.showAttachmentsProjector = false;
    },
    projectPreviousAttachment: async function() {
      this.showAttachmentProjection = false;
      await this.$nextTick();

      if (this.projectedAttachmentIndex == 0) {
        this.projectedAttachmentIndex = this.projectedAttachmentListLength - 1;
      } else {
        this.projectedAttachmentIndex--;
      }

      switch (this.projectedAttachmentAction) {
        case "Pick Up In":
          this.projectedAttachment = this.rcPickUpInAttachments[this.projectedAttachmentIndex];
          break;

        case "Pick Up Out":
          this.projectedAttachment = this.rcPickUpOutAttachments[this.projectedAttachmentIndex];
          break;

        case "Drop Off In":
          this.projectedAttachment = this.rcDropOffInAttachments[this.projectedAttachmentIndex];
          break;

        case "Drop Off Out":
          this.projectedAttachment = this.rcDropOffOutAttachments[this.projectedAttachmentIndex];
          break;
      }
      
      this.updateProjectedAttachmentLocation();
      this.showAttachmentProjection = true;
    },
    projectNextAttachment: async function() {
      this.showAttachmentProjection = false;
      await this.$nextTick();

      if (this.projectedAttachmentIndex == this.projectedAttachmentListLength - 1) {
        this.projectedAttachmentIndex = 0;
      } else {
        this.projectedAttachmentIndex++;
      }
      
      switch (this.projectedAttachmentAction) {
        case "Pick Up In":
          this.projectedAttachment = this.rcPickUpInAttachments[this.projectedAttachmentIndex];
          break;

        case "Pick Up Out":
          this.projectedAttachment = this.rcPickUpOutAttachments[this.projectedAttachmentIndex];
          break;

        case "Drop Off In":
          this.projectedAttachment = this.rcDropOffInAttachments[this.projectedAttachmentIndex];
          break;

        case "Drop Off Out":
          this.projectedAttachment = this.rcDropOffOutAttachments[this.projectedAttachmentIndex];
          break;
      }
      
      this.updateProjectedAttachmentLocation();
      this.showAttachmentProjection = true;
    },
    updateProjectedAttachmentLocation: function() {
      if (this.projectedAttachment['gpslatitude'] && this.projectedAttachment['gpslongitude']) {
        this.projectedAttachmentLocation = [
          {
            position: {
              lat: parseFloat(this.projectedAttachment['gpslatitude'].trim()),
              lng: parseFloat(this.projectedAttachment['gpslongitude'].trim()),
            }
          },
        ];
      }
    },
    downloadAttachment: function(attachment) {
      const anchor = document.createElement("a");
      anchor["href"] = `data:${attachment['pictype'].trim()};base64,${attachment['picimage']}`;
      anchor["download"] = attachment["picname"].trim();
      anchor.click();
    },
    uploadAttachmentsClicked: function(status) {
      this.uploadAttachmentAction = status;
      this.showAttachmentsPopup = true;
    },
    attachmentsSelected: async function(files, placeholder) {
      this.uploadAttachmentInputFiles = [];

      const toBase64 = ((blob) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => { resolve(btoa(reader.result)); };
          reader.readAsBinaryString(blob);
        });
      });

      for (let blob of files) {
        this.uploadAttachmentInputFiles.push({
          "picname": blob["name"].trim(),
          "pictype": blob["type"],
          "pictitle": blob["name"],
          "picimage": await toBase64(blob),
          "newlyUploadedByUser": true, // used to flag new attachments
        });
      }
    },
    attachmentsPopupButtonClicked: function(placeholder) {
      if (placeholder == "Cancel") {
        this.showAttachmentsPopup = false;
        return;
      }

      switch (this.uploadAttachmentAction) {
        case "PUI":
          this.rcPickUpInAttachments.push(...this.uploadAttachmentInputFiles);
          break;

        case "PUO":
          this.rcPickUpOutAttachments.push(...this.uploadAttachmentInputFiles);
          break;

        case "DOI":
          this.rcDropOffInAttachments.push(...this.uploadAttachmentInputFiles);
          break;

        case "DOO":
          this.rcDropOffOutAttachments.push(...this.uploadAttachmentInputFiles);
          break;
      }

      if (this.uploadAttachmentInputFiles.length > 0) {
        this.$emit('update:attachmentsChanged', true);
      }
      this.uploadAttachmentInputFiles = [];
      this.showAttachmentsPopup = false;
    },
    saveClicked : async function (e, title) {
      this.$fullscreenLoading(`Updating ${title} status`) // Controller is created in VehicleScheduleController
      const dataToPost = {
        "updatebyfieldvalue" : !this.receivedData ? '' : !this.receivedData['ConsignmentNo'] ? '' : this.receivedData['ConsignmentNo'],
        "container" : this.rcContainerNoInput,
        "status" : '', // unique
        "remarks": '', // unique
        "dateupdated" : '', // unique
        "deviceid" : '',
        "mobileid" : '',
        "journeyguid" : !this.receivedData ? '' : !this.receivedData['JourneyGUID'] ? '' : this.receivedData['JourneyGUID'],
        "sealno" : this.rcSealNoInput,
        "movementtype" : !this.receivedData ? '' : !this.receivedData['MovementType'] ? '' : this.receivedData['MovementType'],
        "trcode" : !this.rcTrailerInput ? '' : !this.rcTrailerInput['VehicleCode'] ? '' : this.rcTrailerInput['VehicleCode'],
        "trdetach" : this.rcTrPotongChecked ? "1" : "0",
        "b2bjourneyguid" : !this.receivedData ? '' : !this.receivedData['B2BJourneyGUID'] ? '' : this.receivedData['B2BJourneyGUID'],
        "b2bcn" : !this.receivedData ? '' : !this.receivedData['B2BConsignmentNo'] ? '' : this.receivedData['B2BConsignmentNo'],
        "b2bcontainer" : this.rcB2BContainerNoInput,
        "b2bsealno" : this.rcB2BSealNoInput,
        "taspicshms" : [], // unique
      }

      switch(title) {
        case 'Pick Up In' : {
          let inputErrors = false;

          if (!this.rcPickUpInDatetime) {
            this.rcPickUpInDatetimeError = 'PUI datetime required!';
            inputErrors = true;
          }

          if (this.rcTrailerInput && Object.keys(this.rcTrailerInput).length == 0) {
            this.rcTrailerError = 'Trailer required!';
            inputErrors = true;
          }

          if (inputErrors) {
            break;
          }

          let uniqueDataToPost = {
            "status": "PUI",
            "remarks": this.rcPickUpInRemarks ? this.rcPickUpInRemarks.trim() : "",
            "dateupdated": !this.rcPickUpInDatetime ? '' : this.rcPickUpInDatetime.formatString('yyyy-MM-dd HH:mm:ss'),
            "taspicshms": this.rcPickUpInAttachments.filter((attachment) => {
                            return attachment["newlyUploadedByUser"]; // find all attachments where this field exists
                          }).map((attachment) => { return { // map filtered attachments to desired format
                            "PicImage": attachment["picimage"],
                            "PicName": attachment["picname"],
                            "PicType": attachment["pictype"],
                            "PicTitle": attachment["pictitle"],
                          };}),
          }
          let finalDataToPost = {...dataToPost, ...uniqueDataToPost};

          const pickUpInUpdateResults = await this.$apiCallV2(`/VehicleSchedule/UpdateStatusTaskMobileHMS`, finalDataToPost);
          if (!Array.isArray(pickUpInUpdateResults)) {
            this.$fullscreenLoading('');
            break;
          }

          if (this.checkSaveValidity(pickUpInUpdateResults)) { // if pick up in successfully updated
            this.rcPickUpInIsDisabled = true; // disable pick up in controls
            this.rcPickUpInHasSaved = true; // show reverse status button
            this.rcPickUpInAttachments = this.rcPickUpInAttachments.map((attachment) => {
              delete attachment["newlyUploadedByUser"]; // delete this field if it exists
              return attachment;
            });
            this.$emit('update:attachmentsChanged', false);

            this.rcPickUpOutIsDisabled = false; // enable pick up out controls
          }

          this.$emit('statusUpdate', e, pickUpInUpdateResults, title, this.rcPickUpInHasSaved);
          break;
        } 
        case 'Pick Up Out' : {
          let inputErrors = false;

          if (!this.rcPickUpOutDatetime) {
            this.rcPickUpOutDatetimeError = 'PUO datetime required!';
            inputErrors = true;
          }

          if (!this.rcContainerNoInput) {
            this.rcContainerNoError = "Container # required!";
            inputErrors = true;
          }

          if (this.receivedData['B2BJourneyGUID'] && !this.rcB2BContainerNoInput) {
            this.rcB2BContainerNoError = "B2B Container # required!";
            inputErrors = true;
          }

          if (inputErrors) {
            break;
          }

          let uniqueDataToPost = {
            "status" : "PUO",
            "remarks": this.rcPickUpOutRemarks ? this.rcPickUpOutRemarks.trim() : "",
            "dateupdated" : !this.rcPickUpOutDatetime ? '' : this.rcPickUpOutDatetime.formatString('yyyy-MM-dd HH:mm:ss'),
            "taspicshms": this.rcPickUpOutAttachments.filter((attachment) => {
                            return attachment["newlyUploadedByUser"]; // find all attachments where this field exists
                          }).map((attachment) => { return { // map filtered attachments to desired format
                            "PicImage": attachment["picimage"],
                            "PicName": attachment["picname"],
                            "PicType": attachment["pictype"],
                            "PicTitle": attachment["pictitle"],
                          };}),
          }
          let finalDataToPost = {...dataToPost, ...uniqueDataToPost};

          const pickUpOutUpdateResults = await this.$apiCallV2(`/VehicleSchedule/UpdateStatusTaskMobileHMS`, finalDataToPost);

          if (!Array.isArray(pickUpOutUpdateResults)) {
            this.$fullscreenLoading('');
            break;
          }

          if (this.checkSaveValidity(pickUpOutUpdateResults)) { // if pick up out successfully updated
            this.rcPickUpOutIsDisabled = true; // disable pick up out controls
            this.rcPickUpOutHasSaved = true; // show reverse status button
            this.rcPickUpOutAttachments = this.rcPickUpOutAttachments.map((attachment) => {
              delete attachment["newlyUploadedByUser"]; // delete this field if it exists
              return attachment;
            });
            this.$emit('update:attachmentsChanged', false);

            this.rcDropOffInIsDisabled = false; // enable drop off in controls
          }

          this.$emit('statusUpdate', e, pickUpOutUpdateResults, title, this.rcPickUpOutHasSaved);

          break;
        }
        case 'Drop Off In' : {
          if (!this.rcDropOffInDatetime) {
            this.rcDropOffInDatetimeError = 'DOI datetime required !';
            break;
          }

          let uniqueDataToPost = {
            "status" : "DOI",
            "remarks": this.rcDropOffInRemarks ? this.rcDropOffInRemarks.trim() : "",
            "dateupdated" : !this.rcDropOffInDatetime ? '' :this.rcDropOffInDatetime.formatString('yyyy-MM-dd HH:mm:ss'),
            "taspicshms": this.rcDropOffInAttachments.filter((attachment) => {
                            return attachment["newlyUploadedByUser"]; // find all attachments where this field exists
                          }).map((attachment) => { return { // map filtered attachments to desired format
                            "PicImage": attachment["picimage"],
                            "PicName": attachment["picname"],
                            "PicType": attachment["pictype"],
                            "PicTitle": attachment["pictitle"],
                          };}),
          };
          let finalDataToPost = {...dataToPost, ...uniqueDataToPost};

          const dropOffInUpdateResults = await this.$apiCallV2(`/VehicleSchedule/UpdateStatusTaskMobileHMS`, finalDataToPost);

          if (!Array.isArray(dropOffInUpdateResults)) {
            this.$fullscreenLoading('');
            break;
          }

          if (this.checkSaveValidity(dropOffInUpdateResults)) { // if drop off in successfully updated
            this.rcDropOffInIsDisabled = true; // disable drop off in controls
            this.rcDropOffInHasSaved = true; // show reverse status button
            this.rcDropOffInAttachments = this.rcDropOffInAttachments.map((attachment) => {
              delete attachment["newlyUploadedByUser"]; // delete this field if it exists
              return attachment;
            });
            this.$emit('update:attachmentsChanged', false);

            this.rcDropOffOutIsDisabled = false; // enable drop off out controls
          }

          this.$emit('statusUpdate', e, dropOffInUpdateResults, title, this.rcDropOffInHasSaved);
          break;
        }
        case 'Drop Off Out' : {
          if (!this.rcDropOffOutDatetime) {
            this.rcDropOffOutDatetimeError = 'DOO datetime required !';
            break;
          }

          let uniqueDataToPost = {
            "status" : "DOO",
            "remarks": this.rcDropOffOutRemarks ? this.rcDropOffOutRemarks.trim() : "",
            "dateupdated" :  !this.rcDropOffOutDatetime ? '' : this.rcDropOffOutDatetime.formatString('yyyy-MM-dd HH:mm:ss'),
            "taspicshms": this.rcDropOffOutAttachments.filter((attachment) => {
                            return attachment["newlyUploadedByUser"]; // find all attachments where this field exists
                          }).map((attachment) => { return { // map filtered attachments to desired format
                            "PicImage": attachment["picimage"],
                            "PicName": attachment["picname"],
                            "PicType": attachment["pictype"],
                            "PicTitle": attachment["pictitle"],
                          };}),
          }
          let finalDataToPost = {...dataToPost, ...uniqueDataToPost};

          const dropOffOutUpdateResults = await this.$apiCallV2(`/VehicleSchedule/UpdateStatusTaskMobileHMS`, finalDataToPost);

          if (!Array.isArray(dropOffOutUpdateResults)) {
            this.$fullscreenLoading('');
            break;
          }

          if (this.checkSaveValidity(dropOffOutUpdateResults)) { // if drop off out successfully updated
            this.rcDropOffOutIsDisabled = true; // disable drop off out controls
            this.rcDropOffOutHasSaved = true; // show reverse status button
            this.rcDropOffOutAttachments = this.rcDropOffOutAttachments.map((attachment) => {
              delete attachment["newlyUploadedByUser"]; // delete this field if it exists
              return attachment;
            });
            this.$emit('update:attachmentsChanged', false);
          }

          this.$emit('statusUpdate', e, dropOffOutUpdateResults, title, this.rcDropOffOutHasSaved);
          break;
        }
      }
      
      this.$fullscreenLoading('');
    },
    getTrailerData : async function () {
      let trailersData = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=TR&available=1`);
      if (trailersData.length > 0 && trailersData) {
        trailersData = this.$jsonNullToStringV2(trailersData)
        trailersData = this.$deepTrimJsonV3(trailersData);
        let trailerArr = trailersData.map(i => {
          i['Keyname'] = `${i['VehicleNo']} (${i['VehicleCode']}) (${i['VehicleLength']})`
          return i;
        })
        this.rcTrailers = trailerArr;
      }
    },
    getStatusesAndAttachments : async function(journeyGUID, b2bJourneyGUID) {
      return (await this.$apiCallV2(`/VehicleSchedule/GetStatusListByJourney`, {
        "journeyguid": journeyGUID,
        "b2bjourneyguid": b2bJourneyGUID
      }))["Journey"]["JI"];
    },
    populateRCData : function () {
      this.resetFlag();
      const statusesAndAttachments = (
        Array.isArray(this.statusesAndAttachments) ? // if it is a b2b consignment (there are 2 containers)
        this.statusesAndAttachments.find((element) => { // find the object where JourneyGUID and B2BJourneyGUID match
          return (
            this.receivedData["JourneyGUID"] == element["journeyguid"] &&
            this.receivedData["B2BJourneyGUID"] == element["b2bjourneyguid"]
          );
        }) :
        this.statusesAndAttachments // else, simply assign the returned object
      );

      let latestCompletedStatus = "none";
      // populating PUI fields
      this.rcPickUpInDatetime = !statusesAndAttachments['PUI Time'] ? null : statusesAndAttachments['PUI Time'].toDate();
      if (this.rcPickUpInDatetime) {
        latestCompletedStatus = "PUI";
      }
      this.rcTrailerInput = this.rcTrailers.find(i => i['VehicleCode'] == this.receivedData['TRCode']);
      this.rcPickUpInRemarks = statusesAndAttachments['PUI Remarks'] || '';

      // populating PUO fields
      this.rcPickUpOutDatetime = !statusesAndAttachments['PUO Time'] ? null : statusesAndAttachments['PUO Time'].toDate();
      if (this.rcPickUpOutDatetime) {
        latestCompletedStatus = "PUO";
      }
      this.rcSealNoInput = !this.receivedData['SealNo'] ? '' : this.receivedData['SealNo'];
      this.rcPickUpOutRemarks = statusesAndAttachments['PUO Remarks'] || '';

      this.rcRequestNoInput = !this.receivedData['RequestNo'] ? '' : this.receivedData['RequestNo'];
      this.rcBillOfLadingNoInput = !this.receivedData['BL_No'] ? '' : this.receivedData['BL_No'];
      this.rcBookingRefNoInput = !this.receivedData['BookingRefNo'] ? '' : this.receivedData['BookingRefNo'];

      this.rcB2BRequestNoInput = !this.receivedData['B2BRequestNo'] ? '' : this.receivedData['B2BRequestNo'];
      this.rcB2BBillOfLadingNoInput = !this.receivedData['B2BBL_No'] ? '' : !this.receivedData['B2BBL_No'];
      this.rcB2BBookingRefNoInput = !this.receivedData['B2BBookingRefNo'] ? '' : this.receivedData['B2BBookingRefNo'];
      this.rcB2BSealNoInput = !this.receivedData['B2BSealNo'] ? '' : this.receivedData['B2BSealNo'];

      this.rcContainerNoInput = !this.receivedData['ContainerNo'] || !this.receivedData['ContainerNo'].trim() ? '' : this.receivedData['ContainerNo'];
      this.rcB2BContainerNoInput = !this.receivedData['B2BContainerNo'] || !this.receivedData['B2BContainerNo'].trim() ? '' : this.receivedData['B2BContainerNo'];

      // populating DOI input fields
      this.rcDropOffInDatetime = !statusesAndAttachments['DOI Time'] ? null : statusesAndAttachments['DOI Time'].toDate();
      if (this.rcDropOffInDatetime) { // this is needed to flag the disability of container
        latestCompletedStatus = "DOI";
      }
      this.rcDropOffInRemarks = statusesAndAttachments['DOI Remarks'] || '';

      // populating DOO input fields
      this.rcDropOffOutDatetime = !statusesAndAttachments['DOO Time'] ? null : statusesAndAttachments['DOO Time'].toDate();
      if (this.rcDropOffOutDatetime) {
        latestCompletedStatus = "DOO";
      }
      this.rcTrPotongChecked = statusesAndAttachments['Trailer Detach'] === "1";
      this.rcDropOffOutRemarks = statusesAndAttachments['DOO Remarks'] || '';

      // enable next status
      switch (latestCompletedStatus) {
        case "none": // if none of the statuses have been completed
          this.rcPickUpInIsDisabled = false;
          break;

        case "PUI":
          this.rcPickUpOutIsDisabled = false;
          break;

        case "PUO":
          this.rcDropOffInIsDisabled = false;
          break;

        case "DOI":
          this.rcDropOffOutIsDisabled = false;
          break;
      }

      // show reverse status button
      switch (latestCompletedStatus) {
        case "DOO":
          this.rcDropOffOutHasSaved = true; // DO NOT INSERT BREAK STATEMENTS

        case "DOI":
          this.rcDropOffInHasSaved = true; // it is supposed to cascade

        case "PUO":
          this.rcPickUpOutHasSaved = true; // this will show the reverse status button for every status above the latest completed status

        case "PUI":
          this.rcPickUpInHasSaved = true;
      }


      // handle attachments
      this.rcPickUpInAttachments = [];
      this.rcPickUpOutAttachments = [];
      this.rcDropOffInAttachments = [];
      this.rcDropOffOutAttachments = [];
      if (statusesAndAttachments["Doc"]) {
        for (let attachment of statusesAndAttachments["Doc"]) {
          switch (attachment["event"].trim()) {
            case "PUI":
              this.rcPickUpInAttachments.push(attachment);
              break;

            case "PUO":
              this.rcPickUpOutAttachments.push(attachment);
              break;

            case "DOI":
              this.rcDropOffInAttachments.push(attachment);
              break;

            case "DOO":
              this.rcDropOffOutAttachments.push(attachment);
              break;
          }
        }
      }
    },
    resetFlag : function () {
      this.rcPickUpInIsDisabled = true;
      this.rcPickUpOutIsDisabled = true;
      this.rcDropOffInIsDisabled = true;
      this.rcDropOffOutIsDisabled = true;

      this.rcPickUpInHasSaved = false;
      this.rcPickUpOutHasSaved = false;
      this.rcDropOffInHasSaved = false;
      this.rcDropOffOutHasSaved = false;
    },
  },
  async mounted() {
    if (!this.data) {
      this.receivedData = null;
      return;
    }

    this.$fullscreenLoading('Getting Trailer No');
    await this.getTrailerData();
    this.receivedData = this.$deepTrimJsonV3(this.data);
    this.$fullscreenLoading('Getting Statuses and Attachments');
    this.statusesAndAttachments = await this.getStatusesAndAttachments(this.receivedData["JourneyGUID"], this.receivedData["B2BJourneyGUID"]);
    this.populateRCData();
    this.$fullscreenLoading();
  },
  watch: {
     data : {
      handler : async function (val) {
        if (!val) {
          this.receivedData = null;
          return;
        }

        this.$fullscreenLoading('Getting Trailer No');
        await this.getTrailerData();
        this.receivedData = this.$deepTrimJsonV3(val);
        this.$fullscreenLoading('Getting Statuses and Attachments');
        this.statusesAndAttachments = await this.getStatusesAndAttachments(this.receivedData["JourneyGUID"], this.receivedData["B2BJourneyGUID"]);
        this.populateRCData();
        this.$fullscreenLoading();
      }, deep : true
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.status-task-main {
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  /* position: relative; */

  > .white-container {
    width: 100%;
    height: fit-content;
    background-color: white;
    margin-bottom: 5px;
    position: relative;
    border: 1px solid black;
    padding: 5px;

    > .left-cont {
      width: calc(100% - 20px);
      height: 100%;

      > .left-row {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;

        :first-child {
          font-weight: bold;
          text-align: left;
        }
        :nth-last-child(1) {
          text-align: right;
        }

        > span {
          max-width: 50%;
        }
      }
    }

    > .right-cont {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 20px;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;

      > :nth-child(1) {
        margin-top: 5px;
      }

      > .right-cont-lower {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        margin-bottom: 5px;
      }

    }
  }

  > .consignment-details {
    overflow: auto;
    width: 100%;
    height: 100%;
    padding: 5px;
    display: flex;
    flex-direction: column;
    /* position: absolute; */
    background-color: white;
    top: 0;
    left: 0;
    border: 1px solid black;

    > .consignment-detail-close {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: sticky;
      top : 0;

      /* > img {
        width: 18px;
        height: 18px;
        cursor: pointer;
      } */

    }
    > .tab-row {
      width: 100%;
      height: fit-content;
      display: flex;
      margin-bottom: 5px;

      :nth-child(1) {
        font-weight: bold;
        min-width: 105px;
      }

      :not(:first-child) {
        width: 100%;
      }
      
    }

  }

  > .radio-call-section {
    width: 100%;
    height: 100%;

    > .radio-call-container {
      width: 100%;
      min-height: 79px;
      height: fit-content;
      background-color: white;
      border-radius: 5px;
      border: 1px solid black;
      position : relative;
      margin-bottom: 5px;

      > .radio-call-title {
        padding : 5px;
        display: flex;
        justify-content: center;
        align-content: center;
        border-bottom-color: black;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        font-weight: bold;
      }

      > .radio-call-content {
        position: relative;
        padding: 5px;
        width: 100%;
        display: flex;

        > .radio-call-container-disabled {
          position : absolute;
          top: 2px;
          left: 2px;
          z-index: 998;
          border-radius: 5px;
          background-color: rgba(225, 225, 225, 0.4);
          height: 100%;
          width: calc(100% - 4px); // 100% minus 4px for horizontal padding after shifting with top and left properties
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          transition: 0.3s;

          > .reverse-status {
            border-radius: 10px;
            padding: 5px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            opacity: 0;
            transition: opacity 0.3s;
            transition: 0.3s;
            cursor: pointer;
            user-select: none;

            > img {
              height: 50px;
              width: 50px;
            }

            > span {
              font-size: 30px;
            }

            &:hover {
              background-color: rgb(120, 120, 120);
            }
          }

          > .not-ready {
            font-size: 22px;
            opacity: 0;
            transition: opacity 0.3s;
            user-select: none;
          }

          &:hover {
            background-color: rgba(225, 225, 225, 0.8);

            > .reverse-status {
              opacity: 1;
            }

            > .not-ready {
              opacity: 1;
            }
          }

          > .under-maintenance {
            width: fit-content;
            height: fit-content;
            padding: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: black;
            color: white;
            opacity: 1;
            border-radius: 5px;

            > img {
              width : 18px;
              height: 18px;
            }
            > :first-child {
              margin-right: 5px;
            }
          }
        }

        > .radio-call-content-left {
          width: 100%;
          padding: 5px;

          > .remarks-box {
            height: 80px;
          }
          
        }

        > .radio-call-content-right {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: flex-start;

          > img {
            width: 20px;
            height: 20px;
            margin: 0 2px 0 2px;
            transition : 0.3s;
            border-radius: 5px;
            cursor: pointer;


            &:hover {
              /* background-color:lightgreen; */
              box-shadow: outset 1px 1px 5px black !important; 
              transform: scale(1.5);
            }
          }
        }
        
      }

      > .radio-call-attachments {
        height: fit-content;
        width: 100%;
        padding: 5px;

        > .radio-call-attachments-header {
          display: flex;
          width: fit-content;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          user-select: none;

          > img {
            transition: 0.3s;
          }

          > .unsaved-attachment-indicator {
            height: 8px;
            width: 8px;
            margin-left: 5px;
            background-color: red;
            border-radius: 20px
          }
        }

        > .radio-call-attachments-content {
          height: fit-content;
          padding: 0 5px 0 5px;
          overflow: hidden;
          border: 1px solid rgb(200,200,200);
          border-radius: 3px;
          transition: max-height 0.3s;

          > .radio-call-attachments-row {
            margin: 2px 0 2px 0;
            // margin-bottom: 5px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            > .radio-call-attachment-thumbnail {
              height: fit-content;
              position: relative;

              > .thumbnail {
                height: 80px;
                width: 80px;
                object-fit: contain;
                cursor: pointer;
              }

              > .unsaved-attachment-indicator {
                height: 30px;
                width: 30px;
                position: absolute;
                bottom: 0;
                right: -5px;
              }
            }
          }

          > .incomplete { // for rows without enough files to fill up the entire row
            justify-content: flex-start !important;
          }
        }
      }
  
    }
  }

  > .reverse-status-popup {

    .reverse-status-popup-content {
      padding: 0 10px 0 10px;
    }
  }

  > .attachments-popup {
    overflow: visible;

    ::v-deep { // deep needed to target the content class inside the PopupV2 component
      .content { // NOT the content class for slot, but content class inside PopupV2 itself
        overflow: visible;
      }
    }

    .attachments-popup-content { // slot
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: visible;

      .input-container {
        max-width: 80%;
        overflow: visible;
      }
    }
  }

  > .attachments-projector-container {
    top: $top-nav-height;
    left: 0;
    position: fixed;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    > .close-button {
      height: 50px;
      width: 50px;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 100px;
      background-color: white;
      text-align: center;
      font-size: xx-large;
      cursor: pointer;
      user-select: none;
    }

    > .attachments-projector {
      height: 90%;
      width: 90%;
      display: flex;
      flex-direction: row;

      > .attachment-projection-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex: 3;
        background-color: black;


        > .previous-attachment {
          height: 75px;
          width: 36px;
          font-size: 36px;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;

          &:hover {
            cursor: pointer;
            background: rgba(200,200,200,0.8);
          }
        }

        > .attachment-projection {
          height: 100%;
          width: calc(100% - 72px);
          
          > object {
            height: 100%;
            width: 100%;
            object-fit: scale-down;
          }

          > div {
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-size: 40px;
            background-color: white;

            > span {
              margin: 10px 0 10px 0;
            }

            > button {
              height: 50px;
              width: 150px;
              margin: 10px 0 10px 0;
              font-size: 16px;

              > img {
                height: 24px;
                width: 24px;
              }
            }

          }
        }

        > .next-attachment {
          height: 75px;
          width: 36px;
          font-size: 36px;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          user-select: none;

          &:hover {
            cursor: pointer;
            background: rgba(200,200,200,0.8);
          }
        }

      }

      > .attachment-details {
        flex: 1;
        padding: 10px;
        background-color: white;

        > .header {
          background-color: lightgray;
          text-align: center;
          margin-bottom: 5px;
        }

        > table {
          margin-bottom: 5px;

          td {
            width: 100%;
            word-break: break-all;
          }
        }

        > .attachment-map-container {
          height: 50%;
        }
      }
    }
  }
}

</style>